module.exports = __webpack_public_path__ + "static/floorplan2-9198d8dd6cdd4d4c887a1c0abfa5522a.png";